<template>
  <super-admin-menu-layout>
    <h2 class="mb-2">{{ $t('superadmin_menu.name') }}</h2>
    <p class="mb-4">{{ $t('superadmin_menu.intro') }}</p>
    <v-list>
      <v-list-item to="/superadmin/slow-queries" prepend-icon="fas fa-database">
        <v-list-item-title>{{ $t('superadmin_menu.slow_queries') }}</v-list-item-title>
        <v-list-item-subtitle>{{ $t('superadmin_menu.slow_queries_hint') }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item to="/superadmin/slow-routes" prepend-icon="fas fa-route">
        <v-list-item-title>{{ $t('superadmin_menu.slow_routes') }}</v-list-item-title>
        <v-list-item-subtitle>{{ $t('superadmin_menu.slow_routes_hint') }}</v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </super-admin-menu-layout>
</template>

<script>
import SuperAdminMenuLayout from "@/components/layout/SuperAdminMenuLayout.vue";

export default {
  name: "SuperAdminDashboard",
  components: { SuperAdminMenuLayout },
};
</script>
